import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosPartnerPlatformInstance} from "../../ServerApiManager";
import {useAuthContext} from "../../../contexts/AuthContext";
import {PartnersGroupItem} from "../../../declarations";

export const getPartnerCodes = async (token?: string): Promise<PartnersGroupItem[]> => {
  const result = await axiosPartnerPlatformInstance.get<PartnersGroupItem[], AxiosResponse<PartnersGroupItem[]>>(
    "/partner_selector/all",
    token ? {headers: {Authorization: `Bearer ${token}`}} : undefined
  );
  return result.data;
};

export const useGetPartnerCodes = (
  options?: BaseQueryOptions<PartnersGroupItem[], void>
): BaseUseQueryResult<PartnersGroupItem[]> => {
  const {session} = useAuthContext();
  const token = session?.tokens?.accessToken?.toString();
  return useBaseQuery<PartnersGroupItem[], void>(["partner-codes"], () => getPartnerCodes(token), undefined, options);
};
